import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Premiumcorporatecabbookinginhyderabad() {



  const cardData =
  {
    keyword: 'Premium Corporate Cab Bookings in Hyderabad',
    heading: 'Aaryan Travels: Premium Corporate Cab Bookings in Hyderabad',
    headingDescription: 'Aaryan Travels offers Premium Corporate Cab Bookings in Hyderabad for executives, corporate guests, and business travelers who expect top-class comfort and professionalism. Whether it’s airport transfers from Rajiv Gandhi International Airport, client pickups at HITEC City, intercity meetings, or VIP transportation for events, our fleet of luxury sedans, executive SUVs, and premium vehicles ensures a refined travel experience. With well-trained chauffeurs, GPS-enabled vehicles, and 24/7 service availability, we provide reliable and high-standard mobility solutions for corporate needs. From Gachibowli to Banjara Hills, Madhapur to Jubilee Hills, Aaryan Travels is the trusted name for premium corporate cab services in Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Charminar",
    "description": "Built in 1591 by Sultan Muhammad Quli Qutb Shah, Charminar is the most iconic landmark of Hyderabad. Its four grand minarets and Indo-Islamic architecture attract tourists and photographers alike. Surrounding bazaars like Laad Bazaar are famous for bangles, pearls, and traditional snacks. Illuminated beautifully at night, it becomes a spectacular sight. Charminar is Hyderabad’s timeless symbol of culture and heritage."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic hilltop fortress known for its acoustic architecture and historic significance. Once a thriving diamond trade center, it was home to the famous Kohinoor and Hope diamonds. Visitors enjoy exploring royal chambers, cannons, and panoramic viewpoints. The evening light-and-sound show narrates stories of valor and royalty. Golconda Fort is Hyderabad’s proud monument of strength and legacy."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is the world’s largest film studio complex spread over 2000 acres. It offers movie set tours, adventure rides, live shows, and themed attractions like Hollywood Street and Japanese Gardens. Families enjoy fantasy experiences and carnival-style entertainment. It truly feels like stepping into a cinematic world. Ramoji Film City is Hyderabad’s grand destination of fun and film magic."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar is a heart-shaped lake connecting Hyderabad and Secunderabad. At its center stands a 58-foot monolithic Buddha statue on a rock island. Boat rides during sunset offer scenic views of the city skyline. The surrounding Necklace Road is popular for walks, food stalls, and recreation. Hussain Sagar is Hyderabad’s peaceful waterfront landmark."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum houses one of the world’s largest private art collections. Exhibits include European paintings, Mughal weapons, Persian carpets, and rare clocks. Highlights like the Veiled Rebecca statue and musical clock attract huge admiration. Each gallery offers a glimpse into global history and craftsmanship. Salar Jung Museum is Hyderabad’s artistic treasure trove."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a beautiful white marble temple dedicated to Lord Venkateswara. Built atop Naubat Pahad hill, it offers panoramic views of the city and Hussain Sagar Lake. The temple’s serene ambiance and intricate carvings provide spiritual peace. Lit up at night, it looks divine against the skyline. Birla Mandir is Hyderabad’s tranquil beacon of devotion."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was once the official residence of the Nizams. Its grand courtyards, Belgian chandeliers, and vintage car collection reflect royal luxury. Visitors walk through majestic halls and lush gardens while imagining life in the royal era. Cultural events are often held here. Chowmahalla Palace is Hyderabad’s living legacy of aristocracy."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid is one of India’s oldest and largest mosques. Built using soil from Mecca, it showcases magnificent domes, arches, and peaceful courtyards. Thousands gather here for daily prayers. The serene environment and elegant structure make it a must-visit. Mecca Masjid is Hyderabad’s grand spiritual sanctuary."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of the largest zoos in India, home to tigers, lions, elephants, and a wide range of birds. Safari rides and toy trains make it an exciting family outing. The lush greenery and educational displays attract nature lovers. Nehru Zoo is Hyderabad’s wildlife adventure zone."
  },
  {
    "title": "Laad Bazaar",
    "description": "Located beside Charminar, Laad Bazaar is famous for its lacquer bangles, pearls, and traditional bridal accessories. Narrow lanes filled with colorful shops and street snacks create a festive shopping experience. Bargaining and buying is pure joy here. Laad Bazaar is Hyderabad’s vibrant shopping paradise."
  }
],


"services": [
  {
    "name": "Premium Corporate Cab Bookings in Hyderabad",
    "description": "Premium Corporate Cab Bookings in Hyderabad offers tailored transportation solutions for businesses, ensuring comfort, punctuality, and professionalism. Our premium vehicles and trained chauffeurs are ideal for executives, client pickups, and employee transfers, delivering a refined corporate travel experience."
  },
  {
    "name": "Hyderabad Corporate Premium Cab",
    "description": "Hyderabad Corporate Premium Cab provides high-end vehicles for business travel needs across the city. Designed for professionals and corporate clients, our service guarantees reliable, comfortable, and timely rides with courteous, uniformed chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Executive Cab Booking Hyderabad",
    "description": "Executive Cab Booking Hyderabad caters to top-level professionals requiring dependable and stylish transportation. Our premium sedans and experienced chauffeurs ensure a smooth and comfortable ride for meetings, airport commutes, and business travel across the city."
  },
  {
    "name": "Chauffeur Corporate Cab Hyderabad",
    "description": "Chauffeur Corporate Cab Hyderabad delivers discreet, punctual, and professional chauffeur services tailored for corporate clients. Our chauffeurs are trained in business etiquette and drive premium vehicles to provide an exceptional executive travel experience."
  },
  {
    "name": "Premium Business Taxi Hyderabad",
    "description": "Premium Business Taxi Hyderabad is your go-to service for corporate rides in luxury and comfort. Whether for executives, guests, or employees, our fleet includes high-end sedans and SUVs operated by trained drivers who value punctuality and professionalism."
  },
  {
    "name": "Corporate Luxury Cab Hyderabad",
    "description": "Corporate Luxury Cab Hyderabad offers premium cabs with elegant interiors and top-tier amenities, perfect for business travel. From daily commutes to special events, our service ensures your staff and clients travel in comfort, class, and safety."
  },
  {
    "name": "Staff Cab Booking Hyderabad",
    "description": "Staff Cab Booking Hyderabad provides reliable and scheduled transportation for company employees. Our service ensures timely pickups and drops with GPS tracking, clean vehicles, and trained drivers, supporting safe and efficient daily commutes."
  },
  {
    "name": "Premium Office Cab Hyderabad",
    "description": "Premium Office Cab Hyderabad delivers high-quality transportation for office staff and executives. We offer customized corporate plans, monthly billing, and premium vehicles to ensure smooth, on-time travel for daily office commutes and corporate visits."
  },
  {
    "name": "Corporate Chauffeur Hyderabad",
    "description": "Corporate Chauffeur Hyderabad offers experienced, well-trained chauffeurs to drive your executives in style. With knowledge of city routes, punctual service, and professional behavior, our chauffeurs ensure a superior business travel experience every time."
  },
  {
    "name": "Monthly Premium Corporate Cab Hyderabad",
    "description": "Monthly Premium Corporate Cab Hyderabad provides businesses with flexible, subscription-based cab services. Ideal for daily commutes, meetings, or executive travel, we offer luxury vehicles, priority bookings, and detailed monthly invoicing for hassle-free operations."
  },
  {
    "name": "Corporate Vehicle Rental Hyderabad",
    "description": "Corporate Vehicle Rental Hyderabad offers a wide selection of sedans, SUVs, and premium cars on rental for short or long durations. Suitable for staff transportation, events, or executive travel, our rental plans are flexible, affordable, and professional."
  },
  {
    "name": "Online Premium Corporate Cab Hyderabad",
    "description": "Online Premium Corporate Cab Hyderabad simplifies corporate travel bookings with a user-friendly platform. Schedule rides, manage accounts, track vehicles, and receive instant confirmations for premium cab services tailored to business needs."
  },
  {
    "name": "Premium Corporate Transport Hyderabad",
    "description": "Premium Corporate Transport Hyderabad offers comprehensive transport solutions for businesses, including staff commutes, executive pickups, and client visits. Our professional drivers, premium vehicles, and 24x7 support ensure seamless business mobility."
  },
  {
    "name": "Hyderabad Business Cab",
    "description": "Hyderabad Business Cab provides dependable and comfortable transport for business professionals and teams. Our service focuses on timely arrivals, clean vehicles, and well-trained drivers to ensure smooth business operations and transfers."
  },
  {
    "name": "Best Corporate Premium Cab Hyderabad",
    "description": "Recognized as the Best Corporate Premium Cab Hyderabad service, we provide top-rated business transport with luxury vehicles, dedicated support, and on-time performance. Ideal for companies seeking reliable, high-end transportation solutions for employees and executives."
  }
],
"tableData": [
  ["Premium Corporate Cab Bookings in Hyderabad", "Hyderabad Corporate Premium Cab"],
  ["Executive Cab Booking Hyderabad", "Chauffeur Corporate Cab Hyderabad"],
  ["Premium Business Taxi Hyderabad", "Corporate Luxury Cab Hyderabad"],
  ["Staff Cab Booking Hyderabad", "Premium Office Cab Hyderabad"],
  ["Corporate Chauffeur Hyderabad", "Monthly Premium Corporate Cab Hyderabad"],
  ["Corporate Vehicle Rental Hyderabad", "Online Premium Corporate Cab Hyderabad"],
  ["Premium Corporate Transport Hyderabad", "Hyderabad Business Cab"],
  ["Best Corporate Premium Cab Hyderabad", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Premium Corporate Cab Bookings in Hyderabad",
    "WhyChoosedescription": "Aaryan Travels provides premium corporate cab services in Hyderabad for professional and comfortable business travel."
  },
  {
    "WhyChooseheading": "Timely and Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers ensure punctual pickups and drop-offs, making your corporate travel seamless and stress-free."
  },
  {
    "WhyChooseheading": "Luxurious and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in sanitized, premium cars maintained to deliver comfort and style throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Hyderabad Routes",
    "WhyChoosedescription": "Our drivers know the city’s roads and traffic patterns to provide efficient and smooth rides."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing that includes all costs such as tolls and driver allowances for hassle-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to assist with your corporate cab bookings and queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Corporate Needs",
    "WhyChoosedescription": "Choose from one-way or round trips designed to fit your business schedule and convenience."
  },
  {
    "WhyChooseheading": "Wide Range of Corporate Vehicle Options",
    "WhyChoosedescription": "Select from sedans, SUVs, or luxury cars suitable for your corporate travel requirements."
  }
]



































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer premium corporate cab bookings in Hyderabad?',
    answer: 'Yes, Aaryan Travels provides exclusive premium corporate cab services in Hyderabad tailored to business needs.',
  },
  {
    question: 'How can I book premium corporate cabs in Hyderabad with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our dedicated 24x7 corporate customer support team.',
  },
  {
    question: 'What types of vehicles are available for premium corporate cab bookings in Hyderabad?',
    answer: 'Aaryan Travels offers a range of premium sedans, SUVs, and luxury cars suitable for corporate travel.',
  },
  {
    question: 'Are drivers trained to handle corporate clients and Hyderabad city routes?',
    answer: 'Absolutely. Our professional drivers are well-trained, licensed, and familiar with Hyderabad routes to ensure timely and comfortable rides.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for corporate cab bookings in Hyderabad?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere in Hyderabad and nearby business hubs.',
  },
  {
    question: 'Is premium corporate cab service available 24x7 in Hyderabad?',
    answer: 'Yes, Aaryan Travels offers 24x7 premium corporate cab services to fit your business schedule.',
  },
  {
    question: 'Are safety and hygiene protocols maintained for premium corporate cabs?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for your protection.',
  },
  {
    question: 'What payment options are accepted for premium corporate cab bookings in Hyderabad?',
    answer: 'We accept cash, corporate accounts, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is customer support available during premium corporate cab rides in Hyderabad?',
    answer: 'Yes, our dedicated 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Rao',
    feedback: 'Aaryan Travels’ premium corporate cab service in Hyderabad is reliable, professional, and perfect for my business trips.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Reddy',
    feedback: 'Efficient and comfortable corporate cab rides with Aaryan Travels in Hyderabad. Highly recommended for corporate travelers!',
    rating: 5,
  },
];



















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const premiumCorporateCabHyderabadSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Premium Corporate Cab Bookings in Hyderabad",
  "description": "Aaryan Travels offers premium corporate cab bookings in Hyderabad with chauffeur-driven executive cars, luxury cabs, and business taxi services tailored for corporate needs.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Hyderabad"
  },
  "serviceType": "Premium Corporate Cab Booking",
  "keywords": "Premium Corporate Cab Bookings in Hyderabad, Hyderabad Corporate Premium Cab, Executive Cab Booking Hyderabad, Chauffeur Corporate Cab Hyderabad, Premium Business Taxi Hyderabad, Corporate Luxury Cab Hyderabad, Staff Cab Booking Hyderabad, Premium Office Cab Hyderabad, Corporate Chauffeur Hyderabad, Monthly Premium Corporate Cab Hyderabad, Corporate Vehicle Rental Hyderabad, Online Premium Corporate Cab Hyderabad, Premium Corporate Transport Hyderabad, Hyderabad Business Cab, Best Corporate Premium Cab Hyderabad"
};






  return (
    <div>

<Helmet>
  <title>Premium Corporate Cab Bookings in Hyderabad | Executive & Luxury Corporate Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Book premium corporate cab services in Hyderabad with Aaryan Travels. Executive and luxury chauffeur-driven cabs for business travel, staff transport, and corporate events."
  />
  <meta
    name="keywords"
    content="Premium Corporate Cab Bookings in Hyderabad, Hyderabad Corporate Premium Cab, Executive Cab Booking Hyderabad, Chauffeur Corporate Cab Hyderabad, Premium Business Taxi Hyderabad, Corporate Luxury Cab Hyderabad, Staff Cab Booking Hyderabad, Premium Office Cab Hyderabad, Corporate Chauffeur Hyderabad, Monthly Premium Corporate Cab Hyderabad, Corporate Vehicle Rental Hyderabad, Online Premium Corporate Cab Hyderabad, Premium Corporate Transport Hyderabad, Hyderabad Business Cab, Best Corporate Premium Cab Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(premiumCorporateCabHyderabadSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Premiumcorporatecabbookinginhyderabad;